import ImageRow from "./ImageRow";
import styled from "styled-components";
import { Divider, Stack } from "@mui/material";


const ImageComponent = () => {
    return (
        <div>
            <Title>Logo</Title>
            <ImageRow asset="logo" name="Logo" />
            <Title>Qualité de l'air</Title>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="air_quality-high" name="Qualité de l'air (élevée)" />
                <ImageRow asset="air_quality-mid" name="Qualité de l'air (moyenne)" />
                <ImageRow asset="air_quality-low" name="Qualité de l'air (faible)" />
            </Stack>
            <Title>Coûts</Title>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="cost-high" name="Coûts (élevé)" />
                <ImageRow asset="cost-low" name="Coûts (faible)" />
                <ImageRow asset="cost-mid" name="Coûts (moyen)" />
            </Stack>
            <Title>Énergie</Title>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="energy-high" name="Énergie (élevé)" />
                <ImageRow asset="energy-low" name="Énergie (faible)" />
                <ImageRow asset="energy-mid" name="Énergie (moyen)" />
            </Stack>
            <Title>GES</Title>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="ges-high" name="GES (élevé)" />
                <ImageRow asset="ges-low" name="GES (faible)" />
                <ImageRow asset="ges-mid" name="GES (moyen)" />
            </Stack>
            <Title>Confort thermique</Title>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="thermal_comfort-very-high" name="Confort thermique (très élevé)" />
                <ImageRow asset="thermal_comfort-high" name="Confort thermique (élevé)" />
                <ImageRow asset="thermal_comfort-mid" name="Confort thermique (moyen)" />
            </Stack>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="thermal_comfort-low" name="Confort thermique (faible)" />
                <ImageRow asset="thermal_comfort-very-low" name="Confort thermique (très faible)" />
            </Stack>
            <Title>Confort visuel</Title>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="visual_comfort-very-high" name="Confort visuel (très élevé)" />
                <ImageRow asset="visual_comfort-high" name="Confort visuel (élevé)" />
                <ImageRow asset="visual_comfort-mid" name="Confort visuel (moyen)" />
            </Stack>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="visual_comfort-low" name="Confort visuel (faible)" />
                <ImageRow asset="visual_comfort-very-low" name="Confort visuel (très faible)" />
            </Stack>
            <Title>Météo</Title>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="weather-sunny" name="Ensoleillé" />
                <ImageRow asset="weather-partial" name="Dégagé" />
                <ImageRow asset="weather-clouds" name="Nuages" />
            </Stack>
            <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <ImageRow asset="weather-rain" name="Pluie" />
                <ImageRow asset="weather-thunder" name="Éclairs" />
            </Stack>
        </div>
    );
}

const Title = styled.div`
    font-weight: bold;
    margin: 1em;
`


export default ImageComponent;